import React from 'react';
import { useTranslation } from 'react-i18next';
import BannerCarousel from './BannerCarousel';
import { recommendedGames, recommendedTools } from '../config/recommendedConfig';

/**
 * Sección reutilizable de recomendados.
 * - position="top": Muestra Páginas Recomendadas (se coloca encima del contenido principal)
 * - position="bottom": Muestra Juegos Recomendados (se coloca debajo del contenido principal)
 */
const RecommendedSection: React.FC<{ position: 'top' | 'bottom' }> = ({ position }) => {
  const { t } = useTranslation();

  if (position === 'top') {
    if (recommendedTools.length === 0) return null;
    return (
      <div className="mb-4">
        <BannerCarousel
          items={recommendedTools}
          title={t('home.recommended.pages', 'Páginas Recomendadas')}
          emoji="🌐"
          interval={5000}
          variant="purple"
        />
      </div>
    );
  }

  // bottom
  if (recommendedGames.length === 0) return null;
  return (
    <div className="mt-4">
      <BannerCarousel
        items={recommendedGames}
        title={t('home.recommended.games', 'Juegos Recomendados')}
        emoji="🎮"
        interval={4000}
        variant="primary"
      />
    </div>
  );
};

export default RecommendedSection;
